import React from 'react';
import { useContent } from '../../hooks/useContent';

export const FAQSection: React.FC = () => {
  const { content } = useContent();
  
  if (!content?.faq) return null;

  return (
    <section className="py-20 bg-slate-950">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-12 text-center text-white">
            {content.faq.title}
          </h2>
          <div className="space-y-6">
            {content.faq.items.map((item) => (
              <div key={item.id} className="bg-slate-800 p-6 rounded-xl border border-slate-700">
                <h3 className="text-xl font-semibold text-white mb-3">
                  {item.question}
                </h3>
                <p className="text-gray-400">
                  {item.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};